import { createSelector, Selector } from 'reselect';
import { State } from '../../../../reducers';
import { selectProject } from '../../../project';

export const selectHasProjectValidLocation: Selector<State, boolean> = createSelector(
  [selectProject],
  (project) => !!(project && project.latitude && project.longitude)
);
